import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { DataGridPro } from '@mui/x-data-grid-pro';
import BeatLoader from 'react-spinners/BeatLoader';
import { BrowserRouter as Router } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';

import 'react-toastify/dist/ReactToastify.css';
import { toast, Slide, ToastContainer } from 'react-toastify';

import { logout } from '../Functions/auth';
import { getUserData, checkUserToken, updateSavedGroups, updateSavedLocations } from '../Functions/user';
import { colors, roles, values } from '../Shared/utils';
import { useAppContext } from '../Context/App/Provider';
import { useRealtimeContext } from '../Context/Realtime/Provider';
import { useReportingContext } from '../Context/Reporting/Provider';
import { useEventContext } from '../Context/Event/Provider';
import { decodeHTMLEntities } from '../Functions/utils';

import './App.css';
import ContactEmail from './Shared/ContactEmail';
import LoggedInRoutes from '../Routes/LoggedInRoutes';
import LoggedOutRoutes from '../Routes/LoggedOutRoutes';
import NoFavoriteLocationAlert from './Shared/NoFavoriteLocationAlert';


const versionData = require('../version.json')

export default function App() {
  const { t } = useTranslation();
  const [{ user, version, forceReload }, appDispatch] = useAppContext();
  const [{ selected: rtSelected }, rtDispatch] = useRealtimeContext();
  const [{ selected: rptSelected }, rptDispatch] = useReportingContext();
  const [{ groupsLocationsStatus, refreshSelectedLocations, autoApply, canApply }, eventDispatch] = useEventContext();

  const [loaded, setLoaded] = useState(!!user);
  const [emailPrompt, setEmailPrompt] = useState(false);
  const [noFavoriteLocationAlertPrompt, setNoFavoriteLocationAlertPrompt] = useState(false);

  const [checkTimeout, setCheckTimeout] = useState(0);
  const timeoutValue = 28000; // 28s


  const processCheckConnexion = async (count) => {
    // console.log("processCheckConnexion...", count);

    if (user && user.id) {
      checkUserToken().then(res => {
        if (!res || !res.success) {
          if (count > 12) {
            logout().then(() => {
              appDispatch({ user: {} });
              localStorage.clear();

              setTimeout(() => {
                sessionStorage.clear();
              }, 500);

            });
            console.log("53 - NO TOKEN => SHOULD LOGOUT...");
          }
          else {
            console.log("51 - NO TOKEN... will retry", count);
            rescheduleProcessCheckConnexion(timeoutValue, count + 1);
          }
        }
        else
          rescheduleProcessCheckConnexion(timeoutValue, 0);
      });
    }
  };

  const rescheduleProcessCheckConnexion = (timeout, count) => {

    if (timeout) {
      setTimeout(() => {
        processCheckConnexion(count);
      }, timeout);
    }
  };



  const initialize = useCallback((user) => {
    if (!version) {
      appDispatch({ version: versionData });
    }



    // console.log("64 - user=", user);
    // console.log("65 - rptSelected=", rptSelected);
    // console.log("68 - =", JSON.parse(user.savedLocations));




    const reportingColumns = JSON.parse(user.reportingColumns);

    const selectedGroups = [];
    if (user.savedGroups) {
      const savedGroups = JSON.parse(user.savedGroups);
      const newSavedGroups = [];
      let savedGroupsChanged = false;

      savedGroups.forEach((group, sort) => {
        const found = user.groups.find((element) => {
          return element.id === group;
        });
        // selectedGroups.push(found);
        if (found) {
          selectedGroups.push(
            {
              label: found.name,
              value: found.id,
              favoriteId: found.favoriteId,
              sort
            }
          );
          newSavedGroups.push(group);
        }
        else {
          savedGroupsChanged = true;
          console.log("100 - NOT FOUND=", group);
        }
      });

      // console.log("104 - newSavedGroups=", newSavedGroups);
      if (savedGroupsChanged) {
        updateSavedGroups(JSON.stringify(newSavedGroups));
      }
    }

    const selectedLocations = [];
    if (user.savedLocations) {
      const savedLocations = JSON.parse(user.savedLocations);
      const newSavedLocations = [];
      let savedLocationsChanged = false;

      savedLocations.forEach((location, sort) => {
        const found = user.locations.find((element) => {
          return element.id === location;
        });

        if (found) {
          selectedLocations.push(
            {
              label: found.groupId ? ('\u2001' + found.label) : found.name,
              value: found.id, group: found.groupId ?? null, sort
            }
          );
          newSavedLocations.push(location);
        }
        else {
          savedLocationsChanged = true;
          // console.log("115 - NOT FOUND=", location);
        }
      });

      // console.log("121 - newSavedLocations=", newSavedLocations);
      if (savedLocationsChanged) {
        updateSavedLocations(JSON.stringify(newSavedLocations));
      }
    }

    // console.log("110 - From DB=", selectedGroups, selectedLocations); 

    if (user.roleId > roles.stAdmin) {

      let groups = [];
      if (user.groups && user.groups[0]) {
        groups = [{ label: user.groups[0].name, value: user.groupId, sort: 0 }];
      }

      const locations = [];
      user.locations.forEach((location, sort) => locations.push({
        sort, // Ordering
        value: location.id,
        label: location.label,
        group: location.groupId
      }));

      // Automatically select the group (+ location if the user belongs in only one)
      const pickers = { groups, locations: { all: locations, show: locations } };
      const realtimeSelected = { groups, locations: locations.length === 1 ? [locations[0]] : rtSelected.locations };
      const reportingSelected = {
        groups: groups || selectedGroups,
        locations: locations.length === 1 ? [locations[0]] : (rptSelected.locations.length > 0 ? rptSelected.locations : selectedLocations)
      };

      rtDispatch({ pickers, selected: realtimeSelected });
      rptDispatch({ pickers, selected: reportingSelected /*, reportingColumns*/ });

      // console.log("141 - pickers=", pickers);
      // console.log("142 - selected=", reportingSelected);

      // console.log("197 - call eventDispatch({ groupsLoaded: true, locationsLoaded: true});");
      eventDispatch({ groupsLocationsStatus: "loaded" });
    }
    else {
      const groups = [];
      user.groups.forEach((group, sort) => groups.push({
        label: group.name,
        value: group.id,
        favoriteId: group.favoriteId,
        sort
      }));

      const locations = [];
      user.locations.forEach((location, sort) => locations.push({
        label: location.groupId ? ('\u2001' + location.label) : location.name,
        value: location.id, group: location.groupId ?? null,
        sort
      }));

      // Automatically set Groups + Locations pickers state with context from previous session
      const realtimePickers = {
        groups,
        locations: {
          all: locations,
          show: locations.filter(loc => (
            // Filter from array of selected groups (if only one group is selected, show locations only)
            rtSelected.groups.map(l => l.value).includes(loc.group ?? (rtSelected.groups.length === 1 ? null : loc.value))
          ))
        }
      };

      const reportingPickers = {
        groups,
        locations: {
          all: locations,
          show: locations.filter(loc => (
            // Filter from array of selected groups (if only one group is selected, show locations only)
            (rptSelected.groups.length > 1 ?
              rptSelected.groups.map(l => l.value).includes(loc.group ?? (rptSelected.groups.length === 1 ? null : loc.value)) :
              selectedGroups.map(l => l.value).includes(loc.group ?? (selectedGroups.length === 1 ? null : loc.value))
            )
          ))
        }
      };

      rtDispatch({ pickers: realtimePickers });
      rptDispatch({
        pickers: reportingPickers,
        selected: {
          groups: selectedGroups,
          locations: selectedLocations
        }
        /*, reportingColumns*/
      });

      // console.log("199 - pickers=", reportingPickers);
      // console.log("200 - selected-groups=", selectedGroups);
      // console.log("201 - selected-locations=", selectedLocations);

      appDispatch({ forceReload: false });

      // console.log("234 - call eventDispatch({ groupsLocationsStatus: loaded});");
      // eventDispatch({ groupsLoaded: true, locationsLoaded: true});
      eventDispatch({ groupsLocationsStatus: "loaded" });
    }
  }, [rptSelected, rptDispatch, rtSelected, rtDispatch, appDispatch]);


  // useEffect(() => {// rptSelected
  //   console.log("197 - useEffect...rptSelected");
  // }, [rptSelected]);
  // useEffect(() => {// rptDispatch
  //   console.log("197 - useEffect...rptDispatch");
  // }, [rptDispatch]);
  // useEffect(() => {// rtSelected
  //   console.log("197 - useEffect...rtSelected");
  // }, [rtSelected]);
  // useEffect(() => {// rtDispatch
  //   console.log("197 - useEffect...rtDispatch");
  // }, [rtDispatch]);
  // useEffect(() => {// appDispatch
  //   console.log("197 - useEffect...appDispatch");
  // }, [appDispatch]);


  // useEffect(() => {// loaded
  //   console.log("197 - useEffect...loaded");
  // }, [loaded]);
  // useEffect(() => {// appDispatch
  //   console.log("197 - useEffect...appDispatch");
  // }, [appDispatch]);
  // useEffect(() => {// initialize
  //   console.log("197 - useEffect...initialize");
  // }, [initialize]);
  // useEffect(() => {// t
  //   console.log("197 - useEffect...t");
  // }, [t]);


  useEffect(() => {// loaded, appDispatch, initialize, t
    if (!loaded) {
      setLoaded(true);

      // Redirect to correct route after login
      sessionStorage.setItem('redirect', window.location.pathname);

      // Check signed in state
      const signedIn = localStorage.getItem('signedIn');
      if (!signedIn) return appDispatch({ user: {} });

      // Retrieve user data on first load
      getUserData().then(res => {
        if (!res || !res.success) logout().then(() => {
          appDispatch({ user: {} });
          localStorage.clear();

          setTimeout(() => {
            sessionStorage.clear();
          }, 500);

        });

        else {
          if (res.user.roleId > roles.stAdmin && res.user.locations.length === 0) {
            logout().then(() => {
              appDispatch({ user: {} });
              localStorage.clear();

              setTimeout(() => {
                sessionStorage.clear();
              }, 500);

              return toast(decodeHTMLEntities(t('login.errors.locations.no_location')), { type: 'error' });
            });
          }

          const settings = {
            ...values.defaultSettings,
            ...JSON.parse(res.user.settings)
          };
          if (settings.lang !== localStorage.getItem('lang')) i18next.changeLanguage(settings.lang);

          if (settings.autoLoadAtStartCheck !== undefined && settings.autoLoadAtStartCheck !== true) {
            eventDispatch({ autoApply: "off", canApply: 'on' });
          }
          initialize(res.user);
          appDispatch({ settings, user: res.user });
        }
      });
    }
  }, [loaded/*, appDispatch, initialize, t*/]);


  useEffect(() => {
    // console.log("270 - useEffect... groupsLocationsStatus=", groupsLocationsStatus);
    if (groupsLocationsStatus === "force") {
      setLoaded(false);

      eventDispatch({
        groupsLocationsStatus: "loading", refreshSelectedLocations: "on"
      });
    }
  }, [groupsLocationsStatus]);


  useEffect(() => { // Prompt user to set contact email address if necessary
    // console.log("338 - useEffect... user=", user);

    if (user?.id && !user.contactEmailActivated) {
      if (!sessionStorage.getItem('emailPrompted'))
        setEmailPrompt(true);
    } else if (user?.id && user.contactEmailActivated) {
      sessionStorage.removeItem('emailPrompted');
    }


    // console.log("370 - user=", user);
    let showNoFavoriteLocation = user && user.roleId <= roles.stAdmin;
    if (
      showNoFavoriteLocation && 
      user &&
      user.locations &&
      user.contactEmailActivated && user.contactEmail ) {

      const settings = {
        ...JSON.parse(user.settings)
      };
      // console.log("347 - settings=", settings);

      if ((settings.unexpectedActivityCheck === false || (settings.noActivityDetected === false && settings.activityDecreased === false)) /*|| settings.unexpectedActivityCheck === undefined*/) {
        showNoFavoriteLocation = false;
      }
      // console.log("385 - showNoFavoriteLocation=", showNoFavoriteLocation);

      let i = 0;
      while (
        showNoFavoriteLocation && i < user.locations.length
      ) {
        const location = user.locations[i];
        if (location.label && location.favoriteId && location.enabled && location.status === "production") {
          showNoFavoriteLocation = false;
        }
        i++;
      }
      // console.log("397 - showNoFavoriteLocation=", showNoFavoriteLocation);
    }

    if (user?.id && showNoFavoriteLocation) {
      if (!sessionStorage.getItem('noFavoriteLocationPrompted'))
        setNoFavoriteLocationAlertPrompt(true);
    // } else if (user?.id && !showNoFavoriteLocation) {

    //   console.log("403 - user=", user);
    //   console.log("404 - showNoFavoriteLocation=", showNoFavoriteLocation);
    //   sessionStorage.removeItem('noFavoriteLocationPrompted');
    }

    if (user && user.id && checkTimeout === 0) {
      setCheckTimeout(1);
      rescheduleProcessCheckConnexion(timeoutValue, 0);
    }

    if (!user || !user.id)
      setCheckTimeout(0);

  }, [user]);


  useEffect(() => {// forceReload
    if (forceReload === true) {
      setLoaded(false);
    }
  }, [forceReload]);


  // console.log("388 - emailPrompt=", emailPrompt);
  // console.log("382 - noFavoriteLocationAlertPrompt=", noFavoriteLocationAlertPrompt);

  return (
    <div className="app" id="app">
      <DataGridPro /* Load DataGrid base CSS everywhere */ className="datagrid-invisible" columns={[]} rows={[]} />

      {user ? (
        <Router>
          {user.id ? <>
            {emailPrompt && <ContactEmail setEmailPrompt={setEmailPrompt} />}
            {!emailPrompt && noFavoriteLocationAlertPrompt && <NoFavoriteLocationAlert setNoFavoriteLocationAlertPrompt={setNoFavoriteLocationAlertPrompt} />}
            <LoggedInRoutes />
          </> : <>
            <LoggedOutRoutes />
          </>}
        </Router>
      ) : (
        <div className="loader">
          <BeatLoader color={colors.softthinks} />
        </div>
      )}

      <ToastContainer
        draggable
        closeOnClick
        pauseOnHover
        theme="colored"
        pauseOnFocusLoss
        autoClose={3000}
        transition={Slide}
      />
    </div>
  );
}
